import {type TFunction} from 'i18next'
import {object} from 'yup'

import {getYesNoWithCommentSchema} from './yes-no.validators'

export const getCoolerBagHouseSectionValidationSchema = ({t}: {t: TFunction}) =>
  object().shape({
    baghouseFan5930DamageLeaks: getYesNoWithCommentSchema({t}),
    screwsDragsElevatorDamageLeaks: getYesNoWithCommentSchema({t})
  })
